module.exports = __webpack_public_path__ + "img/symbol_white.b3aff4a1.svg";